module.exports = __webpack_public_path__ + "static/media/g-12.f7a374c6.jpg";